import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { wsFocus } from '../common/actions/websocketActions';

/**
 * Announces the claim this tab is showing to bifrost.
 *
 * Viewing a claim is itself a reason to be notified about it: a user with no
 * association to a claim -- not its sponsor, not an owner or assignee of any of
 * its activities -- still needs the event while they have it open, and the
 * server cannot work that out from the projection. Only the browser knows.
 *
 * Clearing on unmount matters as much as setting: a tab that has left the claim
 * must stop receiving its events.
 */
export const useClaimFocus = (workkardId) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(wsFocus(workkardId));
        return () => dispatch(wsFocus(0));
    }, [dispatch, workkardId]);
};

export default useClaimFocus;
